__turbopack_context__.v({
  "action-step": "SubdomainPicker-module-scss-module__H9gu0q__action-step",
  "card": "SubdomainPicker-module-scss-module__H9gu0q__card",
  "description": "SubdomainPicker-module-scss-module__H9gu0q__description",
  "example": "SubdomainPicker-module-scss-module__H9gu0q__example",
  "illustration": "SubdomainPicker-module-scss-module__H9gu0q__illustration",
  "input-wrapper": "SubdomainPicker-module-scss-module__H9gu0q__input-wrapper",
  "lead": "SubdomainPicker-module-scss-module__H9gu0q__lead",
  "search": "SubdomainPicker-module-scss-module__H9gu0q__search",
  "subdomain-part": "SubdomainPicker-module-scss-module__H9gu0q__subdomain-part",
});
